<template>
<div class="height-100">
  <ckeditor
    :editor="editor"
    v-model="editorData"
    :config="editorConfig"
    @input="getEditorHTML()"
    @ready="getInstance"
  >
  </ckeditor>
   <div class="reply-chain-icon" id="show-reply-chain" v-if="page=='reply-chain'">
      <v-btn
        text
        icon
        v-track="'show-reply-chain'"
        @click="showReplyChain()"
      >
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </div>

</div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import CodeBlock from "@ckeditor/ckeditor5-code-block/src/codeblock";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import List from "@ckeditor/ckeditor5-list/src/list";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Font from "@ckeditor/ckeditor5-font/src/font";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import { GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support';
import { mapGetters } from "vuex";

export default {
  name: "text-editor",
  props: {
    body: [HTMLQuoteElement, String, Object, Boolean],
    page: String,
    threadMsgDateUser: String,
  },
  data() {
    return {
      /** editor */
      editor: ClassicEditor,
      editorData: "",
      editorInstance: null,
      editorConfig: {
        // The configuration of the editor.
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          CodeBlock,
          Alignment,
          Indent,
          IndentBlock,
          List,
          Autoformat,
          Heading,
          Font,
          FontFamily,
          Strikethrough,
          Underline,
          BlockQuote,
          GeneralHtmlSupport
        ],
        toolbar: {
          items: [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "alignment",
            "|",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "link",
            "|",
            "bulletedList",
            "numberedList",
            "|",
          ],
          shouldNotGroupWhenFull: true
        },
        htmlSupport: {
          allow: [
            {
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        }
      },
    };
  },
  mounted() {
    this.setBodyData();
  },
  computed:{
    ...mapGetters({
      isExpanded: 'reply/replyExpanded'
    }),
  },
  methods: {
    getInstance(editor) {
      this.editorInstance = editor;
      this.$emit("onReady", editor);
      this.addLastMsgInThread();
      if(this.page == "reply-chain")
        this.editorData = "<br>" + this.editorData;
      
      // Set focus on CKEditor with a delay to ensure readiness
      setTimeout(() => {
        this.editorInstance.focus();
      }, 200);
    },

    getEditorHTML() {
      this.$emit("update", this.editorData);
    },
    setBodyData() {
      if (!this.body) {
        this.editorData = "";
      } else {
        this.editorData = this.body;
      }
    },

    addLastMsgInThread() {
      if (this.page == "reply-chain") {
        this.editorData =
        `<div id="reply-chain-thread" class="d-none"><blockquote><p>${this.threadMsgDateUser}</p> ${this.editorData}</blockquote></div>`;
      }
    },

    showReplyChain() {
      const selectClass = this.isExpanded ? ".expanded-reply-box " : "";
      const chain = document.querySelector(`${selectClass}#reply-chain-thread`);
      const showReplyChainBtn = document.querySelector(`${selectClass}#show-reply-chain`);

      if (chain.classList.contains('d-none')) {
        chain.classList.remove('d-none');
        showReplyChainBtn.style.display = "none";
      }
    }
  },
};
</script>

<style>
.ck.ck-editor,.ck.ck-editor__main{
  height: 100%;
}
.ck.ck-toolbar {
  border: none !important;
  border-bottom: 1px solid #dbd9d9 !important;
}
.ck.ck-button,
a.ck.ck-button {
  font-size: 11px !important;
}
.ck.ck-content {
  width: 100%;
  height: 100%;
  border: none !important;
  box-shadow: none !important;
  padding: 16px !important;
  color: #212121 !important;
  font-size: 16px !important;
  overflow-y: auto;
}

.reply-chain-icon{
  z-index: 1;
  position: relative;
  background-color: #fff;
}
</style>
